import { CircleNotch } from "@phosphor-icons/react";
import { cn } from "@stylingcv/utils";

type LoaderProps = {
  size?: number;
} & React.HTMLAttributes<HTMLDivElement>;

export const Loader = ({ className, size = 24, ...props }: LoaderProps) => {
  return <CircleNotch size={size} className={cn("animate-spin", className)} {...(props as any)} />;
};
